<template>
  <RevButtonCard
    class="aspect-square w-full"
    :aria-labelledby="titleId"
    :to="ctaUrl"
    :tracking
    @click="$emit('click-item')"
    @focusin="trackHover"
    @mouseenter="trackHover"
  >
    <div
      class="mood-inverse relative flex size-full flex-col justify-end overflow-hidden rounded-lg"
    >
      <RevIllustration
        :alt="title"
        :height="360"
        image-class-names="absolute inset-0 size-full object-cover"
        :src="image"
        :width="360"
      />
      <div
        class="pointer-events-none absolute inset-x-0 bottom-0 h-[77.78%] backdrop-blur-[6px] [mask-image:linear-gradient(to_bottom,transparent_0%,black_100%)]"
      />
      <div
        class="pointer-events-none absolute inset-x-0 bottom-0 h-[77.78%] bg-gradient-to-b from-transparent to-[#121016]/60"
      />
      <div class="relative flex flex-col gap-16 p-24">
        <div class="flex flex-col gap-4">
          <p :id="titleId" class="heading-2 text-static-default-hi">
            {{ title }}
          </p>
          <p
            class="body-1-bold line-clamp-2 h-48 text-static-default-hi"
            :title="description"
          >
            {{ description }}
          </p>
        </div>
        <span
          class="text-onaction-default-hi w-fit rounded-sm bg-action-default-hi px-12 py-6"
        >
          <span class="body-2-bold">{{ ctaLabel }}</span>
        </span>
      </div>
    </div>
  </RevButtonCard>
</template>

<script setup lang="ts">
import { useId } from 'vue'
import { useRouter } from 'vue-router'

import { useTracking } from '@backmarket/nuxt-module-tracking/useTracking'
import { RevButtonCard } from '@ds/components/ButtonCard'
import { RevIllustration } from '@ds/components/Illustration'

const props = defineProps<{
  image: string
  title: string
  description: string
  ctaLabel: string
  ctaUrl: string
  tracking?: Record<string, string>
  position: number
}>()

defineEmits<{
  'click-item': []
}>()

const { trackHoverOver } = useTracking()
const router = useRouter()
const titleId = useId()

function trackHover() {
  trackHoverOver({
    zone: 'header',
    name: 'services',
    value: props.tracking?.value ?? '',
    page_type: router.currentRoute.value.fullPath,
    position: props.position,
  })
}
</script>
